/** Powyżej tylu godzin w dniu grupujemy je porami dnia (rano / południe / popołudnie / wieczór). */
export const GROUPING_THRESHOLD = 4;

/** Do tylu wolnych miejsc pokazujemy komunikat „zostały N". */
export const LOW_CAPACITY_THRESHOLD = 5;

export type DayPeriod = "morning" | "noon" | "afternoon" | "evening";

export const DAY_PERIOD_LABEL_KEYS: Record<DayPeriod, string> = {
  morning: "pora_dnia_rano",
  noon: "pora_dnia_poludnie",
  afternoon: "pora_dnia_popoludnie",
  evening: "pora_dnia_wieczor",
};

export const periodOfHour = (hour: number): DayPeriod => {
  if (hour < 12) return "morning";
  if (hour < 15) return "noon";
  if (hour < 18) return "afternoon";
  return "evening";
};

export interface SlotGroup<T> {
  /** null = brak grupowania (mało godzin w dniu) */
  period: DayPeriod | null;
  items: T[];
}

/**
 * Grupuje sloty porami dnia. Przy małej liczbie godzin zwraca jedną grupę bez nagłówka.
 * Kolejność wejściowa jest zachowana wewnątrz grup.
 */
export function groupSlotsByPeriod<T>(
  items: T[],
  getHour: (item: T) => number,
  threshold: number = GROUPING_THRESHOLD
): SlotGroup<T>[] {
  if (items.length <= threshold) {
    return [{ period: null, items }];
  }
  const order: DayPeriod[] = ["morning", "noon", "afternoon", "evening"];
  const buckets = new Map<DayPeriod, T[]>();
  items.forEach((item) => {
    const period = periodOfHour(getHour(item));
    buckets.set(period, [...(buckets.get(period) ?? []), item]);
  });
  return order.filter((period) => buckets.has(period)).map((period) => ({ period, items: buckets.get(period)! }));
}

export type SlotCapacityKind = "soldOut" | "low" | "count";

export interface SlotCapacity {
  kind: SlotCapacityKind;
  remaining: number;
}

/** Opis liczby miejsc przy godzinie; wyprzedane jest zawsze, liczby tylko gdy obiekt pozwala je pokazywać. */
export function slotCapacity(remaining: number, showPool: boolean): SlotCapacity | null {
  const left = Math.max(0, remaining);
  if (left === 0) return { kind: "soldOut", remaining: 0 };
  if (!showPool) return null;
  return { kind: left <= LOW_CAPACITY_THRESHOLD ? "low" : "count", remaining: left };
}
